import React, { useContext, useEffect } from "react";
import { EntradasContext } from "../../context/EntradasContext";
import { AuthContext } from "../../context/AuthContext";
import BitacoraInput from "../bitacora/BitacoraInput";
import Entradas from "../bitacora/Entradas";
import { AdjuntosContext } from "../../context/AdjuntosContext";
import useProyecto from "../../hooks/useProyecto";
import { ConceptosContext } from "../../context/ConceptosContext";
import { CapacitorContext } from "../../context/CapacitorContext";

const BitacoraConcepto = ({
  idFolder,
  idPartida,
  onChange,
  idConcepto,
  idOrdenCambio,
  idConceptoUbicacion,
  idEstimacionVersion,
}) => {
  const { idProyecto } = useProyecto();

  const { platform } = useContext(CapacitorContext);
  const { concepto } = useContext(ConceptosContext);

  const { max, entradas, postEntrada, getEntradas, clearBitacora } =
    useContext(EntradasContext);

  const { uploadSingleAdjunto } = useContext(AdjuntosContext);

  const { user } = useContext(AuthContext);

  useEffect(() => {
    clearBitacora();
    fetchEntradas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idConcepto, idConceptoUbicacion, idEstimacionVersion, idPartida]);

  const fetchEntradas = async () => {
    const params = {};
    if (idPartida) {
      // Every entrada of the partida and of its destajos/subdestajos/conceptos.
      params.idPartida = idPartida;
      return getEntradas(idProyecto, 0, 25, params);
    }
    if (concepto && concepto !== null) {
      params.idConcepto = concepto.idConcepto;
    } else if (idConcepto) {
      params.idConcepto = idConcepto;
    }

    if (idConceptoUbicacion) {
      params.idConceptoUbicacion = idConceptoUbicacion;
    } else if (idEstimacionVersion) {
      params.idEstimacionVersion = idEstimacionVersion;
    }

    if (idOrdenCambio) {
      params.idOrdenCambio = idOrdenCambio;
    }

    getEntradas(idProyecto, 0, 25, params);
  };

  // Refresh the list and let the parent update its comment counter.
  const handlePosted = () => {
    fetchEntradas();
    if (typeof onChange === "function") onChange();
  };

  const handleSubmit = async (message, adjuntos) => {
    const entradaData = {
      message,
    };
    if (idPartida) {
      entradaData.idPartida = idPartida;
    } else if (concepto && concepto !== null) {
      entradaData.idConcepto = concepto.idConcepto;
    } else if (idConcepto) {
      entradaData.idConcepto = idConcepto;
    }
    if (idConceptoUbicacion) {
      entradaData.idConceptoUbicacion = idConceptoUbicacion;
    } else if (idEstimacionVersion) {
      entradaData.idEstimacionVersion = idEstimacionVersion;
    }
    if(idOrdenCambio) {
      entradaData.idOrdenCambio = idOrdenCambio;
    }
    if (adjuntos.length > 0) {
      adjuntos.forEach(async (file) => {
        const data = await uploadSingleAdjunto(idProyecto, idFolder, file);
        entradaData.idAdjunto = data.idAdjunto;
        await postEntrada(idProyecto, entradaData, handlePosted);
      });
    } else {
      postEntrada(idProyecto, entradaData, handlePosted);
    }
  };

  return (
    <div
      className="position-relative bg-light pb-5"
      style={{
        height: platform === "web" ? "70vh" : "auto",
      }}
    >
      <div
        className="row bg-light px-4 py-3"
        style={{
          height: "calc(100% - 52px)",
        }}
      >
        <Entradas
          scrollCallback={fetchEntradas}
          idUsuario={user.idUsuario}
          idProyecto={idProyecto}
          entradas={entradas}
          user={user}
          max={max}
        />
      </div>
      <BitacoraInput modifier={handleSubmit} />
    </div>
  );
};

export default BitacoraConcepto;
